import {backAdmin} from "../axios";

export const supportApi = [
    {url: `${backAdmin}/support`, name: 'support.tickets.all', method: 'GET'},
    {url: `${backAdmin}/support/{id}`, name: 'support.tickets.delete', method: 'DELETE'},
    {url: `${backAdmin}/support/{id}`, name: 'support.byId', method: 'GET'},
    {url: `${backAdmin}/support/{id}/export`, name: 'support.ticket.export', method: 'GET'},
    {url: `${backAdmin}/support/supports`, name: 'support.all.supports', method: 'GET'},
    {url: `${backAdmin}/support/{id}/status`, name: 'support.change.status', method: 'PUT'},
    {url: `${backAdmin}/support/{id}/assignee`, name: 'support.change.assignee', method: 'PUT'},
    {url: `${backAdmin}/support/{id}/due-date`, name: 'support.change.dueDate', method: 'PUT'},
]